import React from 'react';
import { Button, ButtonType, ButtonColor } from '@lux/buttons';
import { Preset, Tag } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { FunctionColor } from '@lux/tokens';
import { TncAndVoucherPolicy } from '../tnc-voucher-policy';
import { ContentWrapper, StyledEmail, StyledSubscribeText, StyledSwitchAccountButton, StyledSwitchAccountText, SubscribeButtonWrapper, } from './styles';
const noop = () => { };
export const WithSwitchAccountContent = ({ onSubscribe = noop, onSwitchAccount = noop, email = '', }) => {
    return (React.createElement(ContentWrapper, null,
        React.createElement(StyledSubscribeText, { preset: Preset.M, tag: Tag.P },
            React.createElement(Translate, { message: "subscribeToNewsletters" })),
        React.createElement(StyledSwitchAccountText, { preset: Preset.M, color: FunctionColor.function60, tag: Tag.P },
            React.createElement(Translate, { message: "loggedInZalandoAccount" }),
            ' ',
            React.createElement(StyledEmail, { preset: Preset.M, color: FunctionColor.function60, bold: true }, email)),
        React.createElement(StyledSwitchAccountButton, { buttonType: ButtonType.tertiary, color: ButtonColor.dark, onClick: onSwitchAccount },
            React.createElement(Translate, { message: "switchAccount" })),
        React.createElement(TncAndVoucherPolicy, null),
        React.createElement(SubscribeButtonWrapper, null,
            React.createElement(Button, { color: ButtonColor.dark, buttonType: ButtonType.primary, onClick: onSubscribe, fullWidth: true },
                React.createElement(Translate, { message: "signUpAndSave" })))));
};
//# sourceMappingURL=component.js.map